import type { UseQueryResult } from '@tanstack/react-query';
import { useApiProblem } from '@/shared/api';
import { EmptyState } from '@/shared/components';

/**
 * Statt des Rasters, solange der Kalender fehlt: ein leeres Raster sähe aus wie „alles frei“
 * (§11). Ein Fehler nennt den Grund des Servers und bietet „Erneut laden“.
 */
export function PriceCalendarLoadState({ query }: { query: UseQueryResult<unknown> }) {
  const problem = useApiProblem(query.error);
  if (!query.isError) {
    return (
      <p className="text-ink-soft py-8 text-sm" aria-live="polite">
        Kalender wird geladen…
      </p>
    );
  }
  return (
    <EmptyState
      icon="Warning"
      title="Kalender konnte nicht geladen werden"
      description={problem?.detail ?? problem?.title}
      action={{ label: 'Erneut laden', onClick: () => void query.refetch() }}
    />
  );
}
